interface DecisionCardProps {
  title: string;
  context: string;
  decision: string;
  tradeoff: string;
}

export function DecisionCard({ title, context, decision, tradeoff }: DecisionCardProps) {
  return (
    <div className="rounded border border-border bg-bg-surface p-5 transition-colors hover:border-accent">
      <h4 className="font-mono text-sm font-bold text-accent">{title}</h4>
      <div className="mt-3 space-y-2 text-sm">
        <p className="text-text-muted">
          <span className="font-mono text-xs text-text-primary">context:</span> {context}
        </p>
        <p className="text-text-muted">
          <span className="font-mono text-xs text-text-primary">decision:</span> {decision}
        </p>
        <p className="text-text-muted">
          <span className="font-mono text-xs text-text-primary">tradeoff:</span> {tradeoff}
        </p>
      </div>
    </div>
  );
}
